export default __webpack_public_path__ + "./images/aw.0e6e850d.png";